import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-target-languages-modal',
  standalone: true,
  imports: [],
  templateUrl: './target-languages-modal.component.html',
  styleUrl: './target-languages-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetLanguagesModalComponent {
  /**
   * jobId is passed via PopupService.open({ componentInputs }) and used to set
   * the modal header title at the call site (`title: \`Translation ${row.jobId}\``).
   * It is declared here so Angular's setInput() mechanism can resolve it correctly.
   * It is intentionally not rendered inside this component's template.
   */
  readonly jobId             = input.required<string>();
  readonly jobName           = input.required<string>();
  readonly sourceLanguage    = input.required<string>();
  readonly allTargetLanguages = input.required<string[]>();

  readonly totalCount = computed(() => this.allTargetLanguages().length);
}
